import React from 'react';
import './StockMagasin.css';

// Cellule « stock magasin » : pastille + quantité de LA concession, et un
// rappel des autres concessions le cas échéant (†), détaillé en infobulle.
//
// Partagée entre le Carnet de commande (Suivi Pièces Atelier) et l'onglet
// Pièces de la modale d'intervention : deux copies auraient divergé, comme le
// tri des tableaux avant `planning/TriTableau.js`.
//
// ⚠️ La prop s'appelle `partRef` et non `ref` : `ref` est réservé par React
// pour le forwarding sur les composants fonction, et serait silencieusement
// absent des props.
export function StockCell({ partRef, stockMap, loading }) {
  if (loading) return <span className="cc-stock-none">…</span>;
  const entry = stockMap?.[partRef];
  if (!entry) return <span className="cc-stock-none">—</span>;
  const here = entry.concession_stock || 0;
  const others = entry.other_concessions || [];
  const hasOthers = others.length > 0;
  const totalOthers = others.reduce((s, o) => s + (o.stock || 0), 0);
  // Rouge quand la pièce est à zéro ICI mais disponible ailleurs : c'est le cas
  // qui appelle une décision (transfert), pas l'absence pure et simple.
  const dotKind = here > 0 ? 'ok' : (hasOthers ? 'zero' : 'none');
  const tooltipParts = [here > 0 ? `Cette concession : ${here}` : 'Cette concession : 0'];
  if (hasOthers) {
    tooltipParts.push('Autres : ' + others.map(o => `${o.nom} ${o.stock}`).join(' · '));
  }
  return (
    <span className="cc-stock-cell" title={tooltipParts.join('\n')}>
      <span className={`cc-stock-dot ${dotKind}`} />
      <span className={`cc-stock-qty ${here === 0 ? 'zero' : ''}`}>{here}</span>
      {hasOthers && <span className="cc-stock-other">({totalOthers}†)</span>}
    </span>
  );
}

export default StockCell;
